export function initSignTotpSetup(root: HTMLElement): void {
    const input = root.querySelector<HTMLInputElement>('input[name="totpCode"]');

    if (!input) {
        return;
    }

    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'one-time-code');
    input.setAttribute('pattern', '[0-9]{6}');

    input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
    });

    window.requestAnimationFrame(() => {
        input.focus();
    });
}
